import { createEntityAdapter, type EntityState } from '@ngrx/entity';

import { type NavMenu } from '@blaze-shared/elements-domain';

export interface NavMenuState extends EntityState<NavMenu.SharedItem> {
  lastAdded?: {
    itemId?: string;
    subItemId?: string;
  };
}

export const navMenuItemsAdapter = createEntityAdapter<NavMenu.SharedItem>();

export const getNavMenuInitialState = (): NavMenuState => navMenuItemsAdapter.getInitialState({});
